module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Bowie")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head1",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("We are grateful to the University Archives and Special Collections Department, Thurgood Marshall Library, Bowie State University; Fannie L. Basim; Holy Family Catholic Church; Huntington Heritage Society; Jack Blevins; Dr. James Jacobs; James Smart; Katherine Hayes; Maryland State Archives–Maryland Commission on Artistic Property; Mike Rauck; Prince George’s County Historical Society; Sacred Heart Church; Safeway, Inc.; Steve Miller and the Miller family; Rabbi Steve Weisman and Temple Solel; and Susan G. Pearl for photographs and captions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unless otherwise noted, all images are courtesy of City of Bowie Museums.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0